module.exports = __webpack_public_path__ + "img/ep_gsm.28cbbda7.svg";